import { interceptedFetch } from './httpInterceptor';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const createAuthenticatedFetch = (token: string | null) => {
  return async (url: string, options: RequestInit = {}) => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string>),
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await interceptedFetch(`${API_BASE_URL}${url}`, {
        ...options,
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return response;
    } catch (error) {
      // Re-throw fetch errors to be handled by the error handler utility
      throw error;
    }
  };
};

export const getAuthenticatedFetch = () => {
  const token = localStorage.getItem('authToken');
  return createAuthenticatedFetch(token);
};
